import React from 'react';
import { injectIntl } from 'react-intl-next';

import granularPagesMessages from './messages';
import { type Props } from './types';
import Heading from '@atlaskit/heading';

const Header = ({ intl: { formatMessage } }: Props) => (
	// eslint-disable-next-line @atlaskit/design-system/use-heading
	<Heading size="large" as="h2">
		{formatMessage(granularPagesMessages.title)}
	</Heading>
);

export default injectIntl(Header);
